import React, {useEffect, useRef} from "react";
import Phone from '../../../assets/logo/phone.png'
import './CongratsFamilyPlan.css'
import {Button} from "antd";
import {useLocation, useNavigate} from "react-router-dom";
import Header from "../../../components/header/Header";

export default function CongratsFamilyPlan(){

    const navigate=useNavigate();
    const location=useLocation();

    const iccid = location.state.iccid ?? null;
    const eid = location.state.eid ?? null;

    const data=[iccid,eid];

    const isMountedRef = useRef(false);
    const sessionId = localStorage.getItem('sessionId')


    console.log(eid);
    console.log(iccid);

    useEffect(()=>{
        if (!sessionId){
            // Redirect to NotFoundPage if any data is null
            navigate('/not-found-page');
        }
    },[])

    const handleController=()=>{

        // eslint-disable-next-line no-undef
        DataActivationController.doneSelected()

    }

    useEffect(() => {

        // try {
        let paramsWithMeid = {
            eid: eid,
            iccid: iccid,
            alternateSmdpFqdn:"rsp.truphone.com"
        };

        // eslint-disable-next-line no-undef
        DataActivationController.dataPlanAccountUpdatedWithInfo(paramsWithMeid);


    }, data);

    return(
        <>
            <div style={{backgroundColor:"#E6E6E6",width:"100%"}}>
                <Header/>
            </div>

            <div className="congratsDiv">
                <img src={Phone} alt="Phone with SMS AlertPop"/>
                <h3>
                    Congratulations
                </h3>
                <div className="congrats">
                    The request is being processed. Please pay attention to your SMS notifications.
                </div>
                <Button
                    className="mainButton"
                    type="primary"
                    shape="round"
                    style={{ backgroundColor: "#f13434"}}
                    onClick={handleController}
                >
                    DONE
                </Button>
            </div>
        </>

    )
}